import { render, staticRenderFns } from "./LeaveSummaryTab.vue?vue&type=template&id=37d5b6cc"
import script from "./LeaveSummaryTab.vue?vue&type=script&lang=js"
export * from "./LeaveSummaryTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports